import { cn } from '@/lib/utils'
import { isSmallScreenAtom } from '@/atoms/screenSize'
import { sidebarCollapseAtom, enableSingleColumnLayoutAtom } from '@/atoms/preferences'
import { HugeiconsIcon } from '@hugeicons/react'
import { ChevronsLeftIcon, ChevronsRightIcon } from '@hugeicons/core-free-icons'
import { ScrollArea } from '@/components/ui/scroll-area'
import AccountButton from './AccountButton'
import FollowingButton from './FollowingButton'
import RelayFeedButton from './RelayFeedButton'
import ConversationsButton from './ConversationsButton'
import NotificationsButton from './NotificationButton'
import HardcodedFeedsSection from './HardcodedFeedsSection'
import PostButton from './PostButton'
import PendingButton from './PendingButton'
import { useCurrentPubkey } from '@/atoms/session'
import { useAtomValue, useSetAtom } from 'jotai'

export default function PrimaryPageSidebar() {
  const isSmallScreen = useAtomValue(isSmallScreenAtom)
  const sidebarCollapse = useAtomValue(sidebarCollapseAtom)
  const updateSidebarCollapse = useSetAtom(sidebarCollapseAtom)
  const enableSingleColumnLayout = useAtomValue(enableSingleColumnLayoutAtom)
  const pubkey = useCurrentPubkey()

  if (isSmallScreen) return null

  const universe = window.hallway.universe
  const appName = universe.appName.toLowerCase()
  const logoUrl = universe.logoUrl

  return (
    <div
      className={cn(
        'relative flex flex-col pb-2 pt-3 h-full shrink-0 px-2',
        sidebarCollapse ? 'w-16' : 'w-52'
      )}
    >
      <ScrollArea className="flex-1 overflow-auto" scrollBarClassName="z-50">
        <div className="space-y-2">
          {sidebarCollapse ? (
            <div className="px-3 py-3 ml-1 mb-6 w-full flex justify-center">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={appName}
                  className="w-8 h-8 object-contain cursor-pointer"
                  onClick={() => document.dispatchEvent(new Event('quick-switch-toggle'))}
                />
              ) : (
                <span
                  className="cursor-pointer inline-block font-['Cormorant_Garamond'] text-5xl -rotate-10 -translate-x-1"
                  onClick={() => document.dispatchEvent(new Event('quick-switch-toggle'))}
                >
                  {appName[0]}
                </span>
              )}
            </div>
          ) : (
            <div className="pr-8 py-3 mt-2 mb-6 w-full">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={appName}
                  className="h-10 object-contain cursor-pointer"
                  onClick={() => document.dispatchEvent(new Event('quick-switch-toggle'))}
                />
              ) : (
                <span
                  className="cursor-pointer inline-flex items-center font-['Cormorant_Garamond'] text-7xl tracking-tighter ml-1"
                  onClick={() => document.dispatchEvent(new Event('quick-switch-toggle'))}
                >
                  <span className="inline-block -rotate-10 -translate-x-1">{appName[0]}</span>
                  {appName.slice(1)}
                </span>
              )}
            </div>
          )}
          {pubkey && <FollowingButton collapse={sidebarCollapse} />}
          {pubkey && <NotificationsButton collapse={sidebarCollapse} />}
          {pubkey && <RelayFeedButton collapse={sidebarCollapse} />}
          {pubkey && <ConversationsButton collapse={sidebarCollapse} />}
          <HardcodedFeedsSection collapse={sidebarCollapse} />
          <PendingButton collapse={sidebarCollapse} />
        </div>
        <div className="h-4" />
      </ScrollArea>
      <div className="shrink-0">
        {pubkey && <PostButton collapse={sidebarCollapse} />}
        <button
          className={cn(
            'absolute bottom-0 flex flex-col justify-center items-center w-5 h-6 p-0 rounded-l-md text-muted-foreground bg-background/80 hover:text-foreground hover:bg-background transition-colors [&_svg]:size-4 z-10',
            enableSingleColumnLayout ? '' : 'hover:shadow-md',
            sidebarCollapse ? '-right-2' : '-right-4'
          )}
          onClick={(e) => {
            e.stopPropagation()
            updateSidebarCollapse(!sidebarCollapse)
          }}
        >
          {sidebarCollapse ? (
            <HugeiconsIcon icon={ChevronsRightIcon} />
          ) : (
            <HugeiconsIcon icon={ChevronsLeftIcon} />
          )}
        </button>
        <AccountButton collapse={sidebarCollapse} />
      </div>
    </div>
  )
}
